<template>
  <div>
    <form-table
      ref="baseForm"
      :queryOptions="searchFormData"
      :tableOptions="tableOptions"
      :headerTitle="headerTitle"
      :queryUrl="queryUrl"
      :query-permission="['system:notice:query']"
      :is-need-operate="true"
      :initSearchParams="initSearchParams"
      @on-change="getMOReportList"
    >
    <template slot="custom-title">
      <div class="wrapper">
          <template v-if="moReportList.length > 0">
            <span class="title">当月每个产品线完成提交的情况：</span>
            <div class="list-wrapper">
              <div class="list-item" v-for="(item, i) in moReportList" :key="item.i">
                <span class="list-item-title">{{ item.bl }}</span>
                <span class="list-item-content">
                  <van-icon name="success"  class="green" v-if="item.reportFlag"/>
                  <van-icon name="cross"  class="red" v-else/>
                </span>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template slot="table-btn" slot-scope="data">
        <span
          @click="doDelete(data.row)"
          v-show="currentYear == data.row.uploadYear && currentMonth == data.row.uploadMonth"
          >删除</span
        >
      </template>
    </form-table>
  </div>
</template>
<script>
import { tableOptions, queryUrl, searchFormData } from './config'
import { delMOHistory, getMOListApi } from '@/api/file'
import { getDicts } from '@/api/dict/data'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      headerTitle: 'MO收集',
      queryUrl: queryUrl,
      tableOptions: tableOptions,
      searchFormData: searchFormData,
      initSearchParams: {
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      currentYear: dayjs(new Date()).format('YYYY'),
      currentMonth: dayjs(new Date()).format('M'),
      moReportList: []
    }
  },
  created() {
    this.setOptions()
  },
  mounted() {
    this.getMOReportList()
  },
  methods: {
    getMOReportList() {
      const { uploadMonth, uploadYear } = this.$refs.baseForm.queryParams
      let params = {
        uploadYear: uploadYear,
        uploadMonth: uploadMonth
      }
      getMOListApi(params).then(res => {
        this.moReportList = res.data
      })
    },
    async setOptions() {
      const productLineList = await getDicts('mo_product_line').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
        }
        return list
      })
      this.tableOptions[0].rightTop.left.options = productLineList
    },
    doDelete(data) {
      let params = {
        id: data.id,
        fileId: data.fileId
      }
      this.$dialog
        .confirm({
          message: '是否确认删除该文件？'
        })
        .then(() => {
          delMOHistory(params).then(({ code, msg }) => {
            if (code != 200) {
              this.$toast.fail({
                message: msg,
                className: 'fail'
              })
              return
            }
            this.$toast.success('删除成功')
            this.$refs.baseForm.onRefresh()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang="less">
.item {
  color: #0b41cd;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  justify-content: space-between;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.name {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.wrapper .title {
  font-size: 14px;
  display: block;
}
.list-wrapper {
  display: inline-flex;
  text-align: center;
  border: 1px solid rgb(197 196 196);
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  flex-wrap: wrap;
}
.list-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid rgb(197 196 196);
  font-size: 16px;
}
.list-item:last-child{
  border-right: none;
}
.list-item-title {
  border-bottom: 1px solid rgb(197 196 196);
  background-color: #efeded;
  line-height: 2;
  color: rgb(11, 65, 205);
  white-space: nowrap;
  font-size: 14px;
}
.list-item-content {
  line-height: 2;
  font-weight: bolder;
}
.green {
  color: #00923a;
}
.red {
  color: #f56c6c;
}
.font-weight-bold {
  font-weight: bold;
}
</style>
